import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import { navLinks } from "../mock";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <motion.header initial={{ y: -60, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.6 }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? "glass-nav" : "bg-white/50 backdrop-blur-md"}`}>
      <div className="max-w-6xl mx-auto px-6 h-14 flex items-center justify-between">
        <Link to="/"><Logo height={40} /></Link>
        <nav className="hidden lg:flex items-center gap-7">
          {navLinks.map((l) => (
            <Link key={l.href} to={l.href} className={`text-[13px] transition-colors ${pathname === l.href ? "text-[#0e2408] font-medium" : "text-[#1d1d1f]/85 hover:text-[#0e2408]"}`}>{l.label}</Link>
          ))}
        </nav>
        <div className="hidden lg:block">
          <Link to="/contact" className="inline-flex items-center rounded-full btn-gold text-[13px] font-semibold px-4 py-2">Get Started Free</Link>
        </div>
        <button className="lg:hidden text-[#1d1d1f]" onClick={() => setOpen((o) => !o)} aria-label="menu">{open ? <X size={20} /> : <Menu size={20} />}</button>
      </div>
      {open && (
        <div className="lg:hidden glass-nav border-t border-black/5 px-6 py-4 flex flex-col gap-3">
          {navLinks.map((l) => (
            <Link key={l.href} to={l.href} className="text-[#1d1d1f] py-1">{l.label}</Link>
          ))}
          <Link to="/contact" className="inline-flex justify-center rounded-full btn-gold font-semibold px-4 py-2 mt-2">Get Started Free</Link>
        </div>
      )}
    </motion.header>
  );
}
